import { useManageConsultees, useManageAllTeams } from 'api';
import { Consultee, PaginationInfo, ValueLabelResponse, Organisation } from 'types';

interface UseUserPanelRecordsResponse {
  users?: Consultee[];
  teamOptions?: ValueLabelResponse[];
  recordCount: number;
  totalCount: number;
  paginationInfo?: PaginationInfo;
}

export const useUserPanelRecords = (
  organisation?: Organisation
): UseUserPanelRecordsResponse => {
  const { data: consulteesQuery } = useManageConsultees(organisation?.organisationName);
  const { data: allTeams } = useManageAllTeams({
    parentOrganisationId: organisation?.id,
  });

  const teamOptions = allTeams?.organisations;

  if (!teamOptions) {
    return {
      recordCount: 0,
      totalCount: 0,
    };
  }

  return {
    users: consulteesQuery?.consultees.items,
    teamOptions: teamOptions,
    recordCount: consulteesQuery?.consultees.items.length ?? 0,
    totalCount: consulteesQuery?.paginationInfo.totalCount ?? 0,
    paginationInfo: consulteesQuery?.paginationInfo,
  };
};
